import React, {useEffect, useState} from 'react';
import Pallet from "../../http_request/Model/pallet/Pallet";
import {toast} from "react-toastify";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";
import {useDispatch} from "react-redux";
import {Button, Form, Input, Select} from "antd";
import {getFilterBranch} from "../../microComponents/tablePages/getFilterBranch";
import ComponentCard from "../../microComponents/elements/ComponentCard";
import {handleAddAgain} from "../../store/SettingRedux/SettingRedux";
import {useParams} from "react-router-dom";


const CreateEditInfoOrder = ({setOrderId, data, reset, create, show, edit}) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [branchLoading, setBranchLoading] = useState(false);
    const [branchList, setBranchList] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    let {id} = useParams();
    useEffect(() => {

        getFilterBranch((e) => {
            setBranchList(e)
            form.setFieldValue('branchId', e[0].value)
        }, setBranchLoading)
    }, [form]);
    useEffect(() => {

        form.setFieldsValue(data)

        if (data) {
            setIsEdit(true)
        }
    }, [data,form]);

    const onFinish = (values) => {
        Pallet.request({
            beforeSend: () => {
                setLoading(true)

            }, success: (res) => {
                setOrderId(values.orderNumber)
                toast.success('تغییرات با موفقیت اعمال شد.');
                dispatch(getAgainHandler())
                dispatch(handleAddAgain(true))

                setIsEdit(true)


            }, error: (error) => {
                // toast.error(error.data.message);

            }, final: () => {
                setLoading(false)

            },


        }).editCreateOrder(isEdit ? 'put' : 'post', values, id);
    };

    useEffect(() => {
        form.resetFields()
        setIsEdit(false)

    }, [reset,form]);
    const onFinishFailed = () => {
    };
    return (<div>
            <ComponentCard>
                <Form
                    name="basic"
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    // initialValues={rowData || {status: true, exireDateInDays: false,}}
                    onFinishFailed={onFinishFailed}
                >


                    <div className="grid grid-cols-3 gap-4">
                        <Form.Item label="واحد" name="branchId"
                                   rules={[{required: true, message: 'لطفا واحد را وارد کنید!',},]}>
                            <Select showSearch placeholder='واحد' defaultActiveFirstOption={true}

                                    suffixIcon={show && ''}
                                    disabled={show}
                                    loading={branchLoading}
                                    filterOption={(input, option) => {
                                        return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                    }}
                                    optionFilterProp='label'
                                    options={branchList}/>
                        </Form.Item>
                        <Form.Item name="orderNumber" label="شماره حواله"
                                   rules={[{required: true, message: 'لطفا شماره حواله را وارد کنید!',},]}
                        >


                            <Input
                                disabled={show}/>
                        </Form.Item>
                        <Form.Item label="مشتری" name="customer"
                        >
                            <Input
                                disabled={show}/>
                        </Form.Item>

                        <Form.Item label="مبدا" name="from">
                            <Input
                                disabled={show}/>
                        </Form.Item>
                        <Form.Item label="مقصد" name="to">
                            <Input
                                disabled={show}/>
                        </Form.Item>

                        <Form.Item


                            name="description"
                            label="توضیحات"

                        >
                            <Input.TextArea row={4}
                                            disabled={show}/>

                        </Form.Item>
                    </div>
                    {!show &&
                    <div className='flex justify-end '>
                        <Form.Item>
                            {isEdit ? <Button className='defBtn orangeBtn' type="primary" htmlType="submit"
                                              loading={loading}>
                                    ویرایش
                                </Button>

                                : <Button className='defBtn blueBtn' type="primary" htmlType="submit"
                                          loading={loading}>
                                    ثبت
                                </Button>}

                        </Form.Item>
                    </div>
                    }
                </Form>
            </ComponentCard>
        </div>);
};

export default CreateEditInfoOrder;